import {
    Box,
    Button,
    Container,
    Grid,
    Pagination,
    PaginationItem,
    Stack,
    Tab,
    Tabs,
    useTheme,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TabPanel = ({ children, value, index }) => {
    return (
        <div hidden={value !== index}>
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
};

const AllGallerycollection = ({ onLoaded = () => { } }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [clothesTypes, setClothesTypes] = useState([]);
    const [selectedType, setSelectedType] = useState("All");
    const [tabData, setTabData] = useState([]);
    const [imageVisible, setImageVisible] = useState(false);
    const [imagePath, setImagePath] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const itemsPerPage = 20;

    const fetchClothesTypes = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/grouped-latest-products`);
            const uniqueTypes = [...new Set(res.data?.data?.map((item) => item.ClothesType))];
            setClothesTypes(["All", ...uniqueTypes]);
        } catch (err) {
            console.error("Failed to fetch clothes types", err);
        }
    };

    const fetchProducts = async (type = "All", page = 1) => {
        try {
            const typeParam = type === "All" ? "" : `type=${encodeURIComponent(type)}&`;
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetAllProduct?${typeParam}page=${page}&limit=${itemsPerPage}`);
            setTabData(res?.data?.data);
            setTotalPages(res.data.totalPages);
        } catch (err) {
            console.error("Error fetching products:", err);
        } finally {
            onLoaded();
        }
    };

    useEffect(() => {
        fetchClothesTypes();
    }, []);

    useEffect(() => {
        fetchProducts(selectedType, currentPage);
    }, [selectedType, currentPage]);

    const openImage = (imgPath) => {
        setImageVisible(true);
        setImagePath(imgPath);
        document.body.style.overflow = "hidden";
    };

    const closeTheImage = () => {
        setImageVisible(false);
        setImagePath("");
        document.body.style.overflow = "auto";
    };

    const redirectToShop = (item) => {
        console.log("click", item);
        navigate("/cart/" + item?.unqid);
    }
    console.log("tabDatatabData", tabData);

    return (
        <>
            {imageVisible && (
                <Box onClick={() => closeTheImage()} sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: "rgba(0,0,0,.9)", zIndex: 10 }}>
                    <Box sx={{ position: 'absolute', top: "50%", left: "50%", transform: 'translate(-50%,-50%)', width: { md: "500px" }, height: 'auto', zIndex: 99, textAlign: 'center' }}>
                        <img
                            src={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + imagePath}
                            alt="Displayed"
                            style={{ width: "100%", objectFit: 'cover' }}
                        />
                    </Box>
                </Box>
            )}
            <Box sx={{ backgroundColor: '#000' }}>
                <Container maxWidth='xl'>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{ mb: 9, mt: 10, overflow: 'scroll' }}>
                            <Tabs
                                value={value}
                                onChange={(e, newValue) => {
                                    setValue(newValue);
                                    setSelectedType(clothesTypes[newValue]);
                                    setCurrentPage(1);
                                }}
                                aria-label="custom tabs"
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{
                                    '& .MuiTab-root': {
                                        color: 'white',
                                        border: '1px solid #3c3c3c',
                                        mx: 2,
                                    },
                                    '& .MuiTabs-indicator': {
                                        display: 'none',
                                    },
                                    '& .Mui-selected': {
                                        color: '#fff',
                                        backgroundColor: 'black',
                                        border: '1px solid #3c3c3c',
                                        padding: { xl: '15px 70px', md: '10px 50px !important' },
                                        marginLeft: '16px',
                                        fontFamily: theme.palette.typography.fontFamily1,
                                        fontSize: '18px',
                                        textTransform: 'capitalize',
                                        backgroundColor: theme.palette.primary.gold,
                                    },
                                    '& .MuiTabs-scrollButtons': {
                                        color: 'white',
                                        backgroundColor: 'black',
                                        borderRadius: '50%',
                                        '&.Mui-disabled': {
                                            opacity: 0.3,
                                        },
                                    },
                                }}
                            >
                                {clothesTypes.map((type, index) => (
                                    <Tab key={index} label={type} />
                                ))}
                            </Tabs>
                        </Box>
                    </Box>
                </Container>
                <Container maxWidth='xxl'>
                    <Box sx={{ height: 'auto', pb: 3 }}>
                        {clothesTypes?.map((type, index) => (
                            <TabPanel key={index} value={value} index={index} sx={{ color: '#fff' }}>
                                <Grid container spacing={2}>
                                    {tabData?.map((item, itemIndex) => (
                                        <Grid key={itemIndex} xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Box onClick={() => redirectToShop(item)} sx={{
                                                width: { xl: '423px', lg: '310px', sm: '300px' },
                                                height: { xl: '402px', lg: '290px' },
                                                mt: 4,
                                                overflow: 'hidden',
                                                position: 'relative',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '100%',
                                                    zIndex: '1',
                                                    backgroundColor: '#0000009c',
                                                    top: '0',
                                                    right: '100%',
                                                    transition: 'right 0.3s ease',
                                                    filter: 'blur(0px)',
                                                },
                                                '&:hover': {
                                                    '&::before': {
                                                        right: '0%',
                                                    },
                                                    '& .search': {
                                                        display: 'block'
                                                    }
                                                },
                                            }}>
                                                <img src={item?.ProductImage} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                {/* <img src={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + item?.ProductImage} style={{ width: '100%', height: '100%', objectFit:'cover' }} /> */}
                                                <Box className='search' sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', display: 'none', zIndex: 1 }}>
                                                    <Button><img src='/images/Gallery/download.svg' /></Button>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </TabPanel>
                        ))}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
                        <Stack spacing={4}>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={(event, value) => setCurrentPage(value)}
                                renderItem={(item) => (
                                    <PaginationItem
                                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                        {...item}
                                        sx={{ fontFamily: theme.palette.typography.fontFamily1, fontSize: '20px' }}
                                    />
                                )}
                            />
                        </Stack>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default AllGallerycollection;
